export const API = {
  oauth: '/oauth/token',
  register: '/users/register',
  emailVerify: '/email/verify',
  forgotPassword: '/users/forgot-password',
  resetPassword: '/users/reset-password',
  resetPasswordCodeVerify: '/users/reset-password-code-verify',
  userInfo: '/users/info',
  userUpdate: '/users/update',
  userDestroy: '/users/destroy',
  profile: '/profile',
  profileInfo: '/profile/info',
  selectProfile: '/profile/select',
  updateProfile: '/profile/update',
  chat: '/chat',
  affinity: '/affinity',
  searchBar: '/search-bar',
  profileCoordinates: '/profile-coordinates',
  profileImage: '/profile/image',
  notifications: '/notifications',
  notificationsSeen: '/notifications/seen',
  notificationsSeenAll: '/notifications/seen-all',
  connectionRequestSeenAll: '/profile/friends/seen-all',
  friends: '/friends',
  sendFriendRequest: '/friends/send',
  getFriendsNotifications: '/friends/notifications',
  accept: '/accept',
  deny: '/deny',
  clear: '/clear',
  picture: '/picture',
  banner: '/banner',
  unfriend: '/unfriend',
  connectionsVisibility: '/connections-visibility',
  socialLinks: '/socialLinks',
  socialLinksCategories: '/socialLinks/categories',
  frequency: '/frequency',
  liveLocData: '/profile/update/coordinates',
  pingTest: '/test/ping',
  fileTest: '/test/image',
  dataTest: '/test/update-personal-quote',
  liveUpdate: '/update-markers/live',
  staticUpdate: '/update-markers/static',
  singleUpdate: '/update-markers/single',
  getMarkersWithCW: '/markers/with-cw',
  blockedUser: '/profile/friends/blocked',
  archive: '/profile/friends/archive',
  guestNotification: '/guest-notifications',
  getPosts: '/posts',
  updateLastSeenOfPost: '/posts/update-last-seen',
  postPosts: '/posts/create',
  addImagePosts: '/posts/add-image',
  getImagePosts: '/posts/get-image',
  putPosts: '/posts/update',
  deletePosts: '/posts/delete',
  likePost: '/posts/like',
  sharePost: '/posts/share',
  savePost: '/posts/save',
  getBlogPreference: '/blog-preference',
  blogPreferenceAllContacts: '/blog-preference/all-contacts',
  blogPreferenceAllUsers: '/blog-preference/all-users',
  addBlogPreference: '/blog-preference/add',
  removeBlogPreference: '/blog-preference/remove',
  getComments: '/comments',
  postComments: '/comments/create',
  putComments: '/comments/update',
  likeComment: '/comments/like',
  avatarMarkerBound: '/profile/image-many',
  subscribeToProfile: '/blog-preference/subscribe-profile',
  pinFriend: '/profile/friends/pin-friend',
  getPinnedFriends: '/profile/friends/get-pinned-friends',
  postPostsDraft: '/posts-draft/create',
  putPostsDraft: '/posts-draft/update',
  addImagePostsDraft: '/posts-draft/add-image',
  getPostsDraft: '/posts-draft',
  getImagePostsDraft: '/posts-draft/get-image',
  removeFriendRequest: '/profile/friends/remove-request',
  getEngagementItems: '/engagements/get',
  lastSeenEngagement: '/engagements/update-last-seen',
  eventMarkers: '/event',
  eventData: '/event/single',
  eventSeenAll: '/event/seen-all',
  getSavedEvents: '/event/saved',
  saveEvent: '/event/save',
  getCryptoBalance: '/crypto/balance'
}
